import {
  CheckIcon,
  ExclamationCircleIcon,
  ExclamationTriangleIcon,
} from '@heroicons/react/24/solid'
import { ReactElement, createElement } from 'react'
import * as yup from 'yup'

export const formSchema = yup
  .object({
    aris_dataset: yup.string().required('ARIS Dataset is required'),
    aris_table: yup.string().required('ARIS Table is required'),
    time_range_start: yup.date().nullable(),
    time_range_end: yup.date().nullable(),
    should_trigger_load: yup.boolean().required(),
    is_incremental_table: yup.boolean().required(),
    is_auto_sync: yup.boolean().required(),
  })
  .required()

export type Inputs = {
  aris_dataset: string
  aris_table: string
  time_range_start?: Date | null | undefined
  time_range_end?: Date | null | undefined
  should_trigger_load: boolean
  is_incremental_table: boolean
  is_auto_sync: boolean
}

export type StatusVariant = 'green' | 'red' | 'orange' | 'yellow' | 'gray'

export const getStatusVariant = (status: string): StatusVariant => {
  const statusLower = status.toLowerCase()
  if (
    statusLower.includes('pending') ||
    statusLower.includes('success') ||
    statusLower.includes('completed')
  ) {
    return 'green'
  }
  if (
    statusLower.includes('failed') ||
    statusLower.includes('failure') ||
    statusLower.includes('error')
  ) {
    return 'red'
  }
  if (statusLower.includes('not supported') || statusLower.includes('unsupported')) {
    return 'orange'
  }
  if (statusLower.includes('invalid')) {
    return 'yellow'
  }
  return 'gray'
}

export const getStatusIcon = (variant: StatusVariant): ReactElement | null => {
  const baseClasses = 'flex items-center justify-center size-4 rounded-full shrink-0'

  if (variant === 'green') {
    return createElement(
      'span',
      { className: `${baseClasses} bg-green-600 border-1 border-green-800` },
      createElement(CheckIcon, { className: 'size-3 fill-white text-white' }),
    )
  }

  if (variant === 'red') {
    return createElement(
      'span',
      { className: `${baseClasses} bg-red-600 border-1 border-red-800` },
      createElement(ExclamationTriangleIcon, { className: 'size-3 fill-white text-white' }),
    )
  }

  if (variant === 'orange') {
    return createElement(
      'span',
      { className: `${baseClasses} bg-orange-600 border-1 border-orange-800` },
      createElement(ExclamationCircleIcon, { className: 'size-3 fill-white text-white' }),
    )
  }

  if (variant === 'yellow') {
    return createElement(
      'span',
      { className: `${baseClasses} bg-yellow-500 border-1 border-yellow-700` },
      createElement(ExclamationCircleIcon, { className: 'size-3 fill-black text-black' }),
    )
  }

  return null
}

export const formatTimestamp = (timestamp?: string): string => {
  if (!timestamp) return ''

  const date = new Date(timestamp)
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  const seconds = String(date.getSeconds()).padStart(2, '0')

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
}

